export function makeModelYear(vehicle) {
  const hasMakeModelYear = !!vehicle?.vehicleMake && !!vehicle?.vehicleModel && !!vehicle?.vehicleYear;
  const makeModelYear = `${vehicle?.vehicleYear} ${vehicle?.vehicleMake} ${vehicle?.vehicleModel}`;
  return hasMakeModelYear ? makeModelYear : '';
}

export function makeModelYearVin(vehicle) {
  return vehicle?.vin ? `${makeModelYear(vehicle)} (${vehicle.vin})` : makeModelYear(vehicle);
}
